import * as React from 'react';
import { HeaderFilterTable } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import { casesLawyerService, GET_SETTLEMENT_STATES } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { useApplyFilterMultiple } from '@/hooks/filters/useApplyFilterMultiple';

export const StateFilterPayment = () => {
	const { selected, hasFilter, handleClearAll, handleSelectFilters } =
		useApplyFilterMultiple({ filterKey: 'state' });
	const FILTER_KEY = 'state';
	const [data, setData] = React.useState<Options[]>([]);
	const [search, setSearch] = React.useState('');

	const { data: stateFilterList } = useQuery({
		queryKey: [GET_SETTLEMENT_STATES, search],
		queryFn: () => casesLawyerService.getStates(1, 100, search),
	});

	React.useEffect(() => {
		if (stateFilterList) {
			const auxList: Options[] = [];
			stateFilterList.data.items.map((item) =>
				auxList.push({
					label: item.name,
					value: item.id.toString(),
				})
			);
			setData(auxList);
		}
	}, [stateFilterList]);

	return (
		<HeaderFilterTable
			title="State"
			searchTitle="Search"
			isSearch
			type="multiple"
			handleSearch={setSearch}
			values={selected}
			filterOptions={data}
			classNamePopoverContent="lg:!w-[345px]"
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter(FILTER_KEY)}
		/>
	);
};
